/**
 * Bring Wàng Cái Hǎo Home | Welcome Pawsperity 2018 by Forefront International
 * 2017 (C) Forefront International
 * @designer V-ki, Chris Tang
 * @developer Jayson Yee, James Ooi
 */
import './offset';
import * as states from './states';

// Polyfills
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'whatwg-fetch';
import "babel-core/register";
import "babel-polyfill";

window.addEventListener('DOMContentLoaded', main);
function main() {
  // Configure Google Analytics
  configureGoogleAnalytics();

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const scaleFactor = isMobile ? 1.75 : 1.0;

  // Initialize Phaser Game
  const element = document.getElementById('game');
  const canvasWidth = element.offsetWidth;
  const canvasHeight = element.offsetHeight;
  const game = new Phaser.Game(canvasWidth * scaleFactor, canvasHeight * scaleFactor, Phaser.CANVAS, 'game');
  Object.keys(states).forEach(state => game.state.add(state, states[state]));
  game.state.start('Boot');

  // Activate share button tracking
  trackShareButton();

  // Load latest counter
  loadLatestCounter();

  // Refresh page on orientation change
  refreshOnOrientationChange();
}


function loadLatestCounter() {
  fetch('http://forefront.international/my/welcomepawsperity/counter.php')
    .then((response) => response.text())
    .then((data) => {
      Array
        .from(document.querySelectorAll('[data-counter]'))
        .forEach((counter) => counter.innerHTML = Number(data));
    });
}

function refreshOnOrientationChange() {
  window.addEventListener('orientationchange', (e) => {
    window.location.reload();
  });
}

function configureGoogleAnalytics() {
  // Configure custom metrics mapping
  gtag('config', 'UA-26680473-7', {
    'custom_map': {
      'metric1': 'jump_count',
      'metric2': 'double_jump_count'
    }
  });
}

function trackShareButton() {
  const winShareButton = document.querySelector('[data-share-win]');

  winShareButton.addEventListener('click', (e) => {
    gtag('event', 'share-win');
  });

}


// WEBPACK FOOTER //
// ./js/game.js